module.exports = __webpack_public_path__ + "img/headbg-3.5be63975.png";